import Images from "./ImageImports.js";

export const COMPONENT_DATA = {
  Beaker: {
    "Beaker A": Images.BeakerA,
    "Beaker B": Images.BeakerB,
    "Beaker C": Images.BeakerC,
    "Beaker D": Images.BeakerD,
    "Beaker E": Images.BeakerE,
    "Beaker F": Images.BeakerF,
  },
  "Blotting Paper": Images.Blotting_Paper,
  CellSpreader: Images.CellSpreader,
  Chromatography: Images.ChromatographyColumn,
  "Dialysis tube": {
    "Dialysis tube 0.0": Images.DialysisTube,
    "Dialysis tube 1.0": Images.DialysisTube,
  },
  "Electronic balance": Images.ElectronicBalance,
  Flask: {
    "1x Running Buffer": Images.OneX_Sodium_Borate_Buffer,
    "1x Running Buffer New": Images.OneX_Sodium_Borate_Buffer_Light,
  },
  "Floating Tube Rack": Images.floatingTubeRack,
  Freezer: Images.freezer_closed,
  Gel: {
    Gel: Images.Agarose_Gel,
    Polyacrylamide: Images.PolyacrylamideGel,
  },
  "Gel Box": {
    "Gel Electrophoresis Box": Images.Gel_Electrophoresis_Box,
    "Protein Gel Electrophoresis Box": Images.Protein_Gel_Electrophoresis_Box,
  },
  "Ice Bucket": Images.IceBucket,
  Incubator: Images.Incubator,
  LabTape: Images.LabTape,
  Microcentrifuge: {
    Microcentrifuge: Images.Microcentrifuge,
    MicrocentrifugeNew: Images.MicrocentrifugeNew,
  },
  "Paper towels": Images.PaperTowels,
  Petridish: {
    LB: Images.petridishLB,
    "LB/amp": Images.petridishLBAMP,
    "LB/amp/ara": Images.petridishLBAMPARA,
  },
  Pipette: {
    P2: Images.P2_Pipette,
    P20: Images.P20_Pipette,
    P200: Images.P200_Pipette,
    P1000: Images.P1000_Pipette,
  },
  Solution: {
    Binding: Images.SolutionFalconBB,
    ColumnEquilibrationBuffer: Images.SolutionFalconCEB,
    Elution: Images.SolutionFalconEB,
    Wash: Images.SolutionFalconWB,
    "SDS Buffer": Images.SDSBuffer,
    "Cell Culture": Images.cellCulture,
    "Protein Ladder": Images.proteinLadder,
  },
  "Power Supply": {
    "Power Supply": Images.Power_Supply,
    "Power Supply New": Images.Power_Supply_New,
  },
  "Power Supply Lead": Images.Power_Supply_Leads,
  "Tip Box": {
    P2: Images.P2_Tip_Box,
    P20: Images.P20_Tip_Box,
    P200: Images.P200_Tip_Box,
    P1000: Images.P1000_Tip_Box,
  },
  Trash: {
    Trash: Images.Trash,
    Biohazard: Images.Biohazardous,
  },
  Vortex: Images.Vortex,
  "Water Bath": Images.WaterBath,
  "Waste Collection Jar": Images.WasteCollectionJar,
  "Heat Block": Images.HeatBlock,
  Timer: Images.Timer,
};

export function getImageData(component, props) {
  switch (COMPONENT_DATA[component] instanceof Object) {
    default:
      return COMPONENT_DATA[component][props.type];
    case false:
      return COMPONENT_DATA[component];
  }
}
